<template>
  <div class="flex flex-col">
    <div class="z-[1] py-24 -ml-16">
      <h3 class="ml-16 mb-10 text-h3 text-left">{{ header }}</h3>
      <div class="pl-16 min-h-240 overflow-x-scroll hide-scrollbar relative">
        <ul class="flex flex-row w-full absolute">
          <li v-for="article in selectedArticles" :key="article.title" class="w-228 pr-16">
            <a :href="article.url" class="primary-focus">
              <img :src="article.image + '?w=212'" class="rounded-lg box-shadow-sm mb-8" />
              <h3 class="text-strong-body hover:underline">{{ article.title }}</h3>
            </a>
          </li>
        </ul>
      </div>
      <p class="text-body mb-8 ml-16">
        Have more questions?
        <a class="underline primary-focus" href="https://support.sittercity.com/hc/en-us/">Visit our help center</a>
      </p>
    </div>
    <div class="bg-primary-subdued w-full absolute min-h-360 left-0"></div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'WhatParentsWillSee',
  props: {
    header: {
      default: '',
      type: String,
    },
    articles: {
      default: () => [],
      type: Array,
    },
  },
  computed: {
    selectedArticles(): Array<any> {
      return this.allArticles.filter((article) => {
        return this.articles.includes(article.id);
      });
    },
    allArticles(): Array<any> {
      return [
        {
          id: 'how',
          title: 'How To Create a Good Adventure',
          url: '/sitters/creating-a-good-adventure',
          image:
            '//images.ctfassets.net/wmwzystk5o45/4pEKgOqb9ydhkGxKWjcqxK/724b244a4c7646453cd4aba3816f6c03/how_to_create_a_good_adventure.jpg',
        },
        {
          id: 'what',
          title: 'What To Charge For Your Adventure',
          url: '/sitters/what-to-charge-for-sitter-adventures',
          image:
            '//images.ctfassets.net/wmwzystk5o45/6NpeDMvfY4ryyVjrimUqTX/ca7e352be8ead7276482166733dfd2b7/what_to_charge_for_your_adventure.jpg',
        },
        {
          id: 'safety',
          title: 'Safety Tips For Leading An Adventure',
          url: '/sitters/sitter-adventure-safety-tips',
          image:
            '//images.ctfassets.net/wmwzystk5o45/VJFkiXVGDJq2qfZcCKsBr/9fa562b349a6dbfd69c19169af031b94/safety_tips_for_leading_an_adventure.jpg',
        },
        {
          id: 'get',
          title: 'Get Bookings: Tips For Adventures',
          url: '/sitters/tips-to-increase-booking-for-adventures',
          image:
            '//images.ctfassets.net/wmwzystk5o45/3moCE8OSYj2e3kicMORT3I/56d942c19d67e9657ca620c36d48c499/tips_for_adventures.jpg',
        },
        {
          id: 'preparing',
          title: 'Preparing To Lead Your Adventure: A Checklist',
          url: '/sitters/leading-an-adventure-checklist',
          image:
            '//images.ctfassets.net/wmwzystk5o45/2ufVlK7iu7h3r9W3T56WEf/33e862857f3c5eafb2e335cc50e4426d/preparing_to_lead_your_adventure.jpg',
        },
        {
          id: 'make',
          title: 'Make Your Adventures Post Stand Out',
          url: '/sitters/how-to-make-adventure-posts-stand-out',
          image:
            '//images.ctfassets.net/wmwzystk5o45/2HH2mmsOcyPCp2G62gFX4R/9c3b8030cc23064d1ef48ddec5cca819/make_your_adventure_stand_out.jpg',
        },
      ];
    },
  },
};
</script>
